import { Pressable } from 'react-native';
import { Text } from '@/components/text';
import { hit } from '@/lib/hit-slop';
// Issue #150 Task 6. Identical "way out" link -- Pressable,
// accessibilityRole="button", hitSlop 8, alignSelf: 'flex-start',
// paddingVertical: 6, Text color="$colorSecondary" fontSize="$2" --
// previously hand-rolled at 5 real call sites (profile-view,
// reveal-requests, report-target, block-user, thread-detail) plus
// sign-up's own already-extracted local `CloseLink`, past this
// project's own "extract at the second/third call site" precedent
// (relativeTime/useCurrentLocation's history). Only the LABEL varies
// by intent -- "Back" (dismissing something already loaded/posted),
// "Cancel" (abandoning an in-progress draft, create-thread), "Close"
// (sign-up's auth flow) -- thread-detail's own prior comment already
// documented this as deliberate: "Matches Cancel/Close exactly instead
// -- plain word, no decoration," never a leading chevron glyph (an
// earlier draft's "‹ Back" made a screen reader announce "left angle
// quote Back, button," caught in review).
//
// `edgePadding` -- removed with issue #555: every call site now renders
// through ScreenHeader (src/components/screen-header.tsx), which the
// caller's own 24px page gutter (space token "$6") already insets, so
// the link never touches the screen edge and the prop's two behaviors
// collapsed into one. Reintroduce it only if a real non-header call
// site appears.
export interface BackLinkProps {
  label: 'Back' | 'Cancel' | 'Close';
  onPress: () => void;
}

export function BackLink({ label, onPress }: BackLinkProps) {
  return (
    <Pressable
      accessibilityRole="button"
      {...hit(8)}
      style={{
        alignSelf: 'flex-start',
        alignItems: 'flex-start',
        minHeight: 44,
        minWidth: 44,
        justifyContent: 'center',
      }}
      onPress={onPress}
    >
      {/* Issue #148 AC3's maxFontSizeMultiplier policy: 1.5 for a
          single-word interactive link -- generous room for a user's OS
          text-size setting (WCAG 1.4.4 requires resizable text, so this
          never disables scaling) while still keeping the link readable
          as one line inside its own small tap area rather than
          wrapping awkwardly at extreme OS scale settings. */}
      {/* fontFamily="$body" -- same known gap TextLink's own comment
          now documents: bare `<Text>` has no font-family default,
          unlike Paragraph/Heading. BackLink is a second real instance
          of it, live on every screen that uses Back/Cancel/Close. */}
      <Text color="$colorSecondary" fontSize="$meta" lineHeight="$meta" fontFamily="$body" maxFontSizeMultiplier={1.5}>
        {label}
      </Text>
    </Pressable>
  );
}
